import { useTheme as muiUseTheme } from '@mui/styles'

import type { Theme } from './theme'

const useTheme = () => muiUseTheme<Theme>()

export default useTheme
